<template>
<div>


<!-- Vertically centered scrollable modal -->
<div class="modal _modal-mask" id="eventLog" style="display: block">

<div  class="modal-dialog modal-dialog-centered modal-lg">
   <div class="modal-content ">

  <div class="modal-header">
    <h4 class="modal-title" id="staticBackdropLabel">
       <i class="far fa-sticky-note mr-3" aria-hidden="true"></i>
      <strong>NOTE  -  {{item_header}}
      </strong></h4>
  </div>     
<div class="modal-body">

  <textarea class="form-control" v-focus id="eventLog" name="eventLog" rows="10" cols="100" v-model ="description">

</textarea>

<div class="modal-footer">
  <button type="button" @click="$emit('close')" class="btn btn-secondary" data-dismiss="modal">ANNULLA</button>
  <button @click="saveData()" type="button" class="btn btn-primary">REGISTRA</button>
</div>

</div>



</div>  
</div>
</div>



</div>
</template>
<script>

import api              from '@/api'
import printNotes       from '@/components/mixins/PrintNotes.js'

export default {
  props  : ['item_key','item_type','item_header'],
  mixins : [printNotes],
  
  data () 
  {
    return {
        description : '',
        eventId     : 0,
        spinner     : false
    }
    
    },
   directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        
        el.focus();
      }
    }
  },  
  computed : {
    

     },

   created () 
    {
 
     if(this.item_key>0)
     { 
    
      this.getData()

     }
    },
  methods: {
      saveData()
      {
        if(this.eventId>0)
        {
          this.updateData()  
        }
        else
        {
          this.createData()
        }
      },
      async getData()
      {
           
        this.spinner    = true    
        const data      = {'event_key' : this.item_key,'event_type' : this.item_type} 
        const sp        = {'sp'        : 'spEventLog'}
        const json      = Object.assign(data, sp)

        await api.post(json).then(res => {
          
          if(res.status==200)
            {
             if(res.data.recordsets[0].length>0)
             {   
              this.eventId     = res.data.recordsets[0][0].eventId
              this.description = res.data.recordsets[0][0].event_description
             }
                         
            }
           else if(res.status==500)
           {
                //console.log(res.data)
                                    
           } 
           else
            {
                console.log('Network Error.')                                   
            } 
          

          }).catch(err => {
              
              console.log(err.message)    
              
          }).finally(() => {
              this.spinner = false
        });



      },
      async createData()
      {
        
        this.spinner  = true    
        const data      = {'event_key' : this.item_key,'event_type':this.item_type,'event_description':this.description} 
        const sp        = {'sp' : 'spCreateEventLog'}
        const json      = Object.assign(data, sp);
        await api.post(json).then(res => {
          
          if(res.status==200)
            {
             
             this.$emit('close')            
            }
           else if(res.status==500)
           {
                console.log(res.data)
                                    
           } 
           else
            {
                console.log('Network Error.')                                   
            } 
          

          }).catch(err => {
              
              console.log(err.message)    
              
          }).finally(() => {
          this.spinner = false
        });
      },
     async updateData()
      {
        
        this.spinner  = true    
        const data      = {'eventId' : this.eventId,'event_description':this.description} 
        const sp        = {'sp' : 'spUpdateEventLog'}
        const json      = Object.assign(data, sp);
        await api.post(json).then(res => {
          
          if(res.status==200)
            {
             
             this.$emit('close')            
            }
           else if(res.status==500)
           {
                //console.log(res.data)
                                    
           } 
           else
            {
                console.log('Network Error.')                                   
            } 
          

          }).catch(err => {
              
              console.log(err.message)    
              
          }).finally(() => {
          this.spinner = false
        });
      }




    
  }
}
</script>

<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 18px;  
}
textarea {
  font-family: 'Roboto Condensed';
  font-weight: bold;
}
.modal-header {
  background-color: yellow;
  color           : black;
}
.modal-footer {  
  justify-content: space-between;  
}
</style>
